/**
* @name APP cmmApp
* @autor 
* @description
* # name controller --> homeCtrl
* # As Controller --> home
* brief comment controller test

*/

export default class actualizacioncontroller {

	constructor($scope, $uiGridConstants, $http, perfilSrv, $cookies, ngNotify, UserInfoConstant, GlobalConfig, $state, i18nService) {
		this.$scope = $scope
		this.$state = $state
		this.$uiGridConstants = $uiGridConstants
		this.$http = $http
		this.perfilSrv = perfilSrv
		this.$cookies = $cookies
		this.ngNotify = ngNotify
		this.$scope.UserInfoConstant = UserInfoConstant
		this.globalConfig = GlobalConfig
		i18nService.setCurrentLang('es')

		this.$scope.gridOptionsComplex = {
			enableSorting      : true,
			enableFiltering    : true,
			paginationPageSizes: [ 25, 50, 75, 100 ],
			paginationPageSize : 25,
			columnDefs         : [],
		}

		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.userinfo = details.user
				this.userinfo.role_id = this.$cookies.get('hasRoleId')

				if (this.userinfo.role_id == this.globalConfig.userRolesIds.teacher || 
            this.userinfo.role_id == this.globalConfig.userRolesIds.reviewerUpdatePerfil || 
            this.userinfo.role_id == this.globalConfig.userRolesIds.approverUpdatePerfil) {
					this.main()
				} else {
					this.$state.go('app.unauthorized')
				}
			}
		})
	}

	main() {
		this.perfilSrv.role.getInfo({ param1: this.userinfo.id }).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn')
			} else {
				this.userinfo.teacherId = response.data[0].idTeacher
				this.getRecordsUpdates()
				this.getStates()
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error')
		})
	}

	getRecordsUpdates() {
		if (this.userinfo.role_id == this.globalConfig.userRolesIds.reviewerUpdatePerfil || this.userinfo.role_id == this.globalConfig.userRolesIds.approverUpdatePerfil) {
			this.getColumnsDefinition('revisorAprobador')
			let params = {
				roleId: this.userinfo.role_id,
				userId: this.userinfo.id,
			}

			this.perfilSrv.perfildocenteByRole.actualizaciondePerfilByUserRole(params).$promise.then((dataReturn) => {
				this.$scope.gridOptionsComplex.data = dataReturn.data
			}, (data) => {
				this.ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		} else {
			this.perfilSrv.perfildocente.ActualizaciondePerfil({ teacherId: this.userinfo.teacherId }).$promise.then((dataReturn) => {           
				this.getColumnsDefinition('profesor')
				this.$scope.gridOptionsComplex.data = dataReturn.data
			}, (data) => {
				this.ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}
	}

	getStates() {
		let params = {
			router   : (this.userinfo.role_id == this.globalConfig.userRolesIds.teacher) ? 'resumenDeLogPerfil' : 'resumenDeLogPerfilGral',
			teacherId: (this.userinfo.role_id == this.globalConfig.userRolesIds.teacher) ? this.userinfo.teacherId : undefined,
		}

		this.perfilSrv.perfildocente.getStates(params).$promise.then((response) => {
			if (response.status) {
				this.states = response.data
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error')
		})
	}

	getColumnsDefinition(tipo) {
		var columms = []

		if (tipo == 'revisorAprobador') {
			this.$scope.gridOptionsComplex.columnDefs = [
				{ displayName: 'N° de Ticket', field: 'NTicket', width: '5%' },
				{ displayName: 'Profesor', field: 'dsTeacher', width: '15%' },
				{ displayName: 'Perfil a actualizar', field: 'PerfilActualizar', width: '17%' },
				{ displayName: 'Tipo de actualización', field: 'TipoActualizacion', width: '10%' },
				{ displayName: 'Estado', field: 'Estado', width: '15%' },
				{ displayName: 'Fecha de solicitud', field: 'FechaSolicitud', width: '13%', cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.FechaSolicitud}}</div>' },
				{ displayName: 'Fecha de actualización', field: 'FechaActualizacion', width: '15%' },
				{ displayName    : 'Acciones', field          : 'NTicket', width          : '10%', enableFiltering: false, cellTemplate   : '<div class="ui-grid-cell-contents form_sub_head_action">' +
        '<a ui-sref="profile.actualizacion_update({type: row.entity.idEstado,stage: row.entity.id_stage, title: row.entity.PerfilActualizar, nTicket: row.entity.NTicket, historyType: row.entity.idHistoryType, idUser: row.entity.idUser, nameUser: row.entity.dsTeacher, idTeacher: row.entity.idTeacher})">Ver Detalle</a>' +
        '</div>' },
			]
		} else {
			this.$scope.gridOptionsComplex.columnDefs = [
				{ displayName: 'N° de Ticket', field: 'NTicket', width: '10%' },
				{ displayName: 'Perfil a actualizar', field: 'PerfilActualizar', width: '20%' },
				{ displayName: 'Tipo de actualización', field: 'TipoActualizacion', width: '15%' },
				{ displayName: 'Estado', field: 'Estado', width: '15%' },
				{ displayName: 'Fecha de solicitud', field: 'FechaSolicitud', width: '15%', cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.FechaSolicitud}}</div>' },
				{ displayName: 'Fecha de actualización', field: 'FechaActualizacion', width: '15%' },
				{ displayName    : 'Acciones', field          : 'NTicket', width          : '10%', enableFiltering: false, cellTemplate   : '<div class="ui-grid-cell-contents form_sub_head_action">' +
        '<a ui-sref="profile.actualizacion_update({type: row.entity.idEstado, title: row.entity.PerfilActualizar, nTicket: row.entity.NTicket, historyType: row.entity.idHistoryType, idUser: row.entity.idUser, nameUser: row.entity.dsTeacher, idTeacher: row.entity.idTeacher})">Ver Detalle</a>' +
        '</div>' },
			]
		}
	}

}

actualizacioncontroller.$inject = [ '$scope', 'uiGridConstants', '$http', 'perfilSrv', '$cookies', 'ngNotify', 'UserInfoConstant', 'GlobalConfig', '$state', 'i18nService' ]




// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/Actualizacion_Perfil/actualizacioncontroller.js